import { createContext, useContext, type ReactNode } from 'react'

export const ContentLanguageContext = createContext<string>('en')

interface ContentLanguageProviderProps {
  language?: string | null
  children: ReactNode
}

export function ContentLanguageProvider(props: ContentLanguageProviderProps) {
  const { language, children } = props
  const inherited = useContext(ContentLanguageContext)
  const resolved = (language && language.trim()) || inherited || 'en'

  return (
    <ContentLanguageContext.Provider value={resolved}>
      {children}
    </ContentLanguageContext.Provider>
  )
}

export function useContentLanguage(override?: string | null): string {
  const inherited = useContext(ContentLanguageContext)
  if (override && override.trim()) {
    return override
  }
  return inherited || 'en'
}
